import {AfterViewInit, Directive, ElementRef, Input, NgZone, OnDestroy, Renderer2} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {pairwise, tap} from 'rxjs/operators';

@Directive({
    selector: '[showMoreShowLess]',
})
export class ShowMoreShowLessDirective implements AfterViewInit, OnDestroy {
    @Input('spanContainer') spanContainer: HTMLDivElement;
    @Input('detailsSpan') detailsSpan: HTMLDivElement;
    // @ts-ignore
    width$ = new BehaviorSubject<ResizeObserverEntry>();
    private widthObserver: ResizeObserver;

    constructor(private renderer: Renderer2, private el: ElementRef, private zone: NgZone) {}

    ngAfterViewInit(): void {
        this.listenForWidth();
    }

    listenForWidth() {
        this.widthObserver = new ResizeObserver(entries => {
            this.zone.run(() => {
                for (const entry of entries) {
                    this.width$.next(entry);
                }
            });
        });

        this.widthObserver.observe(this.spanContainer);
        this.widthObserver.observe(this.detailsSpan);

        this.width$.pipe(
            pairwise(),
            tap(listAndContainerPair => {
                if (listAndContainerPair[0] !== undefined && listAndContainerPair[1] !== undefined) {
                    const spanContainer = listAndContainerPair.find(htmlElem => htmlElem?.target['classList'].contains('expandable-text-container'));
                    const detailsSpan = listAndContainerPair.find(htmlElem => htmlElem?.target['classList'].contains('details-span'));

                 if (detailsSpan && spanContainer) {
                     const expandableParentTemplate = this.renderer.parentNode(spanContainer.target) as HTMLTableCellElement;
                     const showLessBtn = expandableParentTemplate.querySelector('.show-less-btn');

                     if ((spanContainer.target.getBoundingClientRect().width - detailsSpan.target.getBoundingClientRect().width) >= 3) {
                         this.renderer.addClass(showLessBtn, 'hide-btn');
                         this.renderer.removeClass(showLessBtn, 'show-btn');
                     } else {
                         this.renderer.addClass(showLessBtn, 'show-btn');
                         this.renderer.removeClass(showLessBtn, 'hide-btn');
                     }
                 }
                }
            }),
        ).subscribe();
    }

    ngOnDestroy() {
        this.widthObserver.unobserve(this.spanContainer);
        this.widthObserver.unobserve(this.detailsSpan);
        this.width$.unsubscribe();
    }
}
